module.exports = __webpack_public_path__ + "static/media/null.bc56ae6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/null.png
// module id = 318
// module chunks = 2